import { render, staticRenderFns } from "./equip.vue?vue&type=template&id=39edc422"
import script from "./equip.vue?vue&type=script&lang=js"
export * from "./equip.vue?vue&type=script&lang=js"
import style0 from "./equip.vue?vue&type=style&index=0&id=39edc422&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports